<!-- Tarjeta hero de la lista de pasos (monta sobre la banda). Estilos: _liga-ui.scss / _liga-a.scss. -->
<header class="lx-hero">
  <div class="lx-hero__cabeza">
    <span class="lx-hero__icono" [class.lx-hero__icono--verde]="todoListo" aria-hidden="true">
      <fa-icon [icon]="todoListo ? iconos.listo : iconos.lista"></fa-icon>
    </span>
    <div class="lx-hero__textos">
      <span class="lx-hero__eyebrow">Tu solicitud</span>
      <h2 class="lx-hero__titulo">{{titulo}}</h2>
      <p class="lx-hero__subtitulo">{{subtitulo}}</p>
    </div>
  </div>

  <div class="lx-avance" *ngIf="avance.total">
    <div class="lx-avance__fila">
      <span *ngIf="avance.listos > 0; else sinAvance"><strong>{{avance.listos}} de {{avance.total}}</strong> listos</span>
      <ng-template #sinAvance><span><strong>{{avance.total}} {{avance.total === 1 ? 'paso' : 'pasos'}}</strong> por completar</span></ng-template>
      <span class="lx-avance__pct">{{avance.listos > 0 ? avance.porcentaje + ' %' : '¡Empecemos!'}}</span>
    </div>
    <div class="lx-avance__barra" role="progressbar" aria-label="Avance de tu solicitud" aria-valuemin="0"
         [attr.aria-valuemax]="avance.total" [attr.aria-valuenow]="avance.listos"
         [attr.aria-valuetext]="avance.listos + ' de ' + avance.total + ' listos'">
      <span class="lx-avance__relleno" [style.width.%]="avance.porcentaje"></span>
    </div>
  </div>

  <p class="lx-a-resumen" *ngIf="resumen.enRevision || resumen.porCorregir">
    <span class="lx-chip lx-chip--revision" *ngIf="resumen.enRevision">
      <fa-icon [icon]="iconos.reloj" aria-hidden="true"></fa-icon>{{resumen.enRevision}} en revisión
    </span>
    <span class="lx-chip lx-chip--corrige" *ngIf="resumen.porCorregir">
      <fa-icon [icon]="iconos.corrige" aria-hidden="true"></fa-icon>{{resumen.porCorregir}} por corregir
    </span>
  </p>
</header>
